import VideoPlaySmall from '@repo/ui/src/components/Icons/VideoPlaySmall';
import { StateSetterFunction } from '@repo/ui/src/types/helpers';

// @TODO deprecate once new buttons are in

interface Props {
  text: string;
  setOpenModal: StateSetterFunction<boolean>;
}

const WatchNowButton = ({ setOpenModal, text }: Props) => {
  return (
    <button
      onClick={() => setOpenModal((curr) => !curr)}
      className="tra-text-web-utl-button-l tw-text-white tw-flex tw-items-center tw-p-2"
    >
      <VideoPlaySmall color="#D95E16" className="tw-mr-4" />
      {text}
    </button>
  );
};

export default WatchNowButton;
